import moment from "moment-timezone";
import { TIME_INTERVAL_MINS } from "constants/timeIntervalMins";

export default function getValidTime(
  min: number,
  max: number,
  isFrom?: boolean,
) {
  const minDate = moment(min);
  const maxDate = moment(max);
  const diffMins = Math.ceil(maxDate.diff(minDate, "m") / TIME_INTERVAL_MINS);
  const minValue = minDate.valueOf();

  // add fall back for edge case
  return Array(Math.max(diffMins || 1, 0))
    .fill(0)
    .map((_, i) => {
      const currValue = new Date(
        minValue + 1000 * 60 * TIME_INTERVAL_MINS * (isFrom ? i : i + 1),
      );
      return currValue.toISOString();
    });
}
